import { render, staticRenderFns } from "./InvoiceDialog.vue?vue&type=template&id=b4c6c558"
import script from "./InvoiceDialog.vue?vue&type=script&lang=ts"
export * from "./InvoiceDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports